// The scope the calendar's scope dropdown names (`calendar-scope-dropdown.tsx`, Antonin's export 22 Oct): "All" with no
// specialty chosen, the one specialty, or the first and "+N" for more.
export function scopeLabel(selected: readonly string[]): string {
  if (selected.length === 0) return 'All';
  if (selected.length === 1) return selected[0];
  return `${selected[0]} +${selected.length - 1}`;
}
